import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";

import header_logo from "../../Assets/header_logo.webp";
import phone_img from "../../Assets/phone_img.webp";
import mail_img from "../../Assets/mail_img.webp";
import instagram_icon from "../../Assets/instagram_icon.webp";
import twitter_icon from "../../Assets/twitte_icon.webp";
import linkedin_icon from "../../Assets/linkedin_icon.webp";
import { FaLinkedinIn, FaXTwitter, FaFacebookF, FaInstagram } from 'react-icons/fa6';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer_section">
      <div className="footer_main">
        <div className="footer_col contact_col">
          <Link to="/" className="footer_logo" onClick={() => handleLinkClick("/")}>
            <img src={header_logo} alt="Logo" />
          </Link>
          <div className="contact_item">
            <img src={phone_img} alt="Phone" />
            <a className="text-decoration-none" href="tel:+91-9925042310">+919925042310</a>
          </div>
          <div className="contact_item">
            <img src={mail_img} alt="Email" />
            <a className="text-decoration-none" href="mailto:khodiyarindustries1@gmail.com">khodiyarindustries1@gmail.com</a>
          </div>
          <div className="contact_item">
            <img src={mail_img} alt="Email" />
            <a className="text-decoration-none" href="mailto:khodiyarindustries2015@gmail.com">khodiyarindustries2015@gmail.com</a>
          </div>
        </div>

        <div className="footer_col links_col">
          <h3>Quick Links</h3>
          <div className="divider" />
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/AboutUs">About</Link></li>
            <li><Link to="/Product">Products</Link></li>
            <li><Link to="/Request_A_Quote">Request A Quote</Link></li>
            <li><Link to="/ContactUs">Contact Us</Link></li>
            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
            <li><Link to="/Sitemap">Site Map</Link></li>
          </ul>
        </div>

        <div className="footer_col products_col">
          <h3>Products</h3>
          <div className="divider" />
          <div className="products_wrapper">
            <ul>
              <li><Link to="/Automotive_Railway_window_glass">- Automotive & Railway Window Glass</Link></li>
              <li><Link to="/Car_Glass">- Car Glass</Link></li>
              <li><Link to="/E_Rickshaw_Spare_Parts_Glass">-E Rickshaw Glass</Link></li>
              {/* <li><Link to="/Automotive_Glass">- Automotive Glass</Link></li> */}
              <li><Link to="/Commercial_Vehicle_Glass">- Commercial Vehicle Glass</Link></li>
              <li><Link to="/Automobile_Toughness_Glass">- Automotive Toughened Glass</Link></li>
            </ul>
            <ul>
              <li><Link to="/Construction_Equipment_Glass">- Road & Construction Equipment Glass</Link></li>
              <li><Link to="/Automative_Laminated_Glass">- Automotive Laminated Glass</Link></li>
              <li><Link to="/Arctitecture_Glass">- Architecture Glass</Link></li>
              <li><Link to="/Home_Appliance_glasses">- Home Appliance Glass</Link></li>
              {/* <li><Link to="/Railway_Window_Glass">- Railway Window Glass</Link></li> */}
              <li><Link to="/DGU_Glass">- DGU Glass</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer_bottom">
        <p>© 2025 Design & Develop by Nodeprix Technology LLP. All Rights Reserved.</p>
        <div className="social_icons mx-3 ">
          <Link to="https://www.linkedin.com/company/your-linkedin-page" className="mx-3" target="_blank" rel="noopener noreferrer" title="LinkedIn" style={{ color: '#0077B5' }}>
                        <FaLinkedinIn size={30} />
                      </Link>
                      <Link to="https://twitter.com/your_twitter" className="mx-3" target="_blank" rel="noopener noreferrer" title="X (formerly Twitter)" style={{ color: '#ffffff' }}>
                        <FaXTwitter size={30} />
                      </Link>
                      <Link to="https://www.facebook.com/your_facebook_page" className="mx-3" target="_blank" rel="noopener noreferrer" title="Facebook" style={{ color: '#1877F2' }}>
                        <FaFacebookF size={30} />
                      </Link>
                      <Link to="https://www.instagram.com/your_instagram" className="mx-3" target="_blank" rel="noopener noreferrer" title="Instagram" style={{ color: '#E4405F' }}>
                        <FaInstagram size={30} />
                      </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
